const REDIRECT_KEY = 'redirect-after-login';

export function saveRedirectPath(path: string): void {
  try {
    sessionStorage.setItem(REDIRECT_KEY, path);
  } catch (error) {
    console.error('Error saving redirect path:', error);
  }
}

export function getRedirectPath(): string | null {
  try {
    return sessionStorage.getItem(REDIRECT_KEY);
  } catch (error) {
    console.error('Error getting redirect path:', error);
    return null;
  }
}

export function clearRedirectPath(): void {
  try {
    sessionStorage.removeItem(REDIRECT_KEY);
  } catch (error) {
    console.error('Error clearing redirect path:', error);
  }
}

// The email verification link usually opens in a new tab, which has an empty
// sessionStorage. Copy the redirect to localStorage before sending users to verify.
const POST_VERIFY_KEY = 'redirect-after-verify';
const POST_VERIFY_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function savePostVerifyRedirect(): void {
  const path = getRedirectPath();
  if (!path) return;
  try {
    localStorage.setItem(POST_VERIFY_KEY, JSON.stringify({ path, savedAt: Date.now() }));
  } catch (error) {
    console.error('Error saving post-verify redirect:', error);
  }
}

export function takePostVerifyRedirect(): string | null {
  try {
    const raw = localStorage.getItem(POST_VERIFY_KEY);
    localStorage.removeItem(POST_VERIFY_KEY);
    if (!raw) return null;
    const { path, savedAt } = JSON.parse(raw) as { path: string; savedAt: number };
    const isLocalPath = typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');
    return isLocalPath && Date.now() - savedAt < POST_VERIFY_MAX_AGE_MS ? path : null;
  } catch {
    return null;
  }
}
